import { Action, State } from "@zyzgroup/core-common";
import { ColorPattern, getCSSVar } from "@zyzgroup/core-web";

export function getColors(colorPattern: ColorPattern) {
  return {
    // 组件：颜色反向
    foregroundReverse: getCSSVar(`--yz-foreground-reverse`, "#ffffff"),
    foregroundBorderReverse: getCSSVar(
      `--yz-foreground-border-reverse`,
      "#e6e6e6"
    ),
    panelReverse: getCSSVar(`--yz-panel-reverse`, "#f5f5f5"),
    panelBorderReverse: getCSSVar(`--yz-panel-border-reverse`, "#b3b3b3"),
    gapReverse: getCSSVar(`--yz-gap-reverse`, "#cccccc"),
    placeholderReverse: getCSSVar(`--yz-placeholder-reverse`, "#8f8f8f"),
    fontReverse: getCSSVar(`--yz-font-reverse`, "#333333"),
    fontSecondaryReverse: getCSSVar(`--yz-font-secondary-reverse`, "#666666"),
    fontTertiaryReverse: getCSSVar(`--yz-font-tertiary-reverse`, "#999999"),

    // 组件：颜色加深
    foregroundCommon: getCSSVar(`--yz-foreground-common`, "#ffffff"),
    foregroundBorderCommon: getCSSVar(
      `--yz-foreground-border-common`,
      "#e6e6e6"
    ),
    panelCommon: getCSSVar(`--yz-panel-common`, "#f5f5f5"),
    panelBorderCommon: getCSSVar(`--yz-panel-border-common`, "#b3b3b3"),
    gapCommon: getCSSVar(`--yz-gap-common`, "#cccccc"),
    placeholderCommon: getCSSVar(`--yz-placeholder-common`, "#8f8f8f"),
    fontCommon: getCSSVar(`--yz-font-common`, "#333333"),
    fontSecondaryCommon: getCSSVar(`--yz-font-secondary-common`, "#666666"),
    fontTertiaryCommon: getCSSVar(`--yz-font-tertiary-common`, "#999999"),

    greenCommon: getCSSVar("--yz-xg-green", "#00be5a"),
    redCommon: getCSSVar("--yz-xg-red", "#fa503c"),
    redSecondaryCommon: getCSSVar("--yz-xg-red-secondary", "#fff5f5"),
    redSecondaryBorderCommon: getCSSVar(
      "--yz-xg-red-secondary-border",
      "#fac8c8"
    ),
    redGradientCommon: getCSSVar("--yz-xg-red-gradient", "#fa8c78"),
    yellowCommon: getCSSVar("--yz-xg-yellow", "#fa8c00"),

    // pattern 加深
    primaryPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-primary`,
      "#5a82f0"
    ),
    secondaryPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-secondary`,
      "#e6f0ff"
    ),
    secondaryBorderCommon: getCSSVar(
      `--yz-pattern-${colorPattern}-secondary-border`,
      "#a0b4f0"
    ),
    gradientPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-gradient`,
      "#66b3ff"
    ),
    foregroundPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-foreground`,
      "#ffffff"
    ),
    foregroundBorderPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-foreground-border`,
      "#e6e6e6"
    ),
    panelPattern: getCSSVar(`--yz-pattern-${colorPattern}-panel`, "#f5f5f5"),
    panelBorderPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-panel-border`,
      "#b3b3b3"
    ),
    gapPattern: getCSSVar(`--yz-pattern-${colorPattern}-gap`, "#cccccc"),
    placeholderPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-placeholder`,
      "#8f8f8f"
    ),
    fontPattern: getCSSVar(`--yz-pattern-${colorPattern}-font`, "#333333"),
    fontSecondaryPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-font-secondary`,
      "#666666"
    ),
    fontTertiaryPattern: getCSSVar(
      `--yz-pattern-${colorPattern}-font-tertiary`,
      "#999999"
    )
  };
}

function reduce(state: State, colorPattern: ColorPattern): State {
  state.colorPattern = colorPattern;
  const colors = getColors(colorPattern);
  for (const k in colors) {
    state[k] = colors[k];
  }
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    const colorPattern: ColorPattern =
      payload?.colorPattern || nextState?.colorPattern || "xg-blue";
    switch (action.type) {
      case "SET_COLOR":
      case "INIT":
      default:
        reduce(nextState, colorPattern);
        break;
    }
    return nextState;
  };
